module.exports = __webpack_public_path__ + "static/media/c3.32948d4b.gif";